import { selectTenantSettings } from '../../redux';
import { useAppSelector } from '../useAppSelector';

export const useTenantSettingsDefaults = () => {
  const tenantSettings = useAppSelector(selectTenantSettings);
  return { defaultCurrencyCode: tenantSettings?.currency?.code ?? 'NOK', defaultCountry: tenantSettings?.country };
};
